<template>
  <div class="lv-dropdown-tree-checkbox-node">
    <div
      v-for="node in nodes"
      :key="node.id"
      class="lv-dropdown-tree-checkbox-node__item"
      :style="{ marginLeft: `${indent}px` }"
    >
      <LvCheckbox
        h5
        :value="node.id"
        :select="$_getSelectValue(node.id)"
        :text="node.title"
        :isParentSelected="$_isParentSelected(node.id)"
        :red="node.color === 'red'"
        justifyContent="flex-start"
        :disable="disableCheckbox"
        @change="$_onToggle(node)"
      />
      <LvDropdownTreeCheckboxNode
        v-if="node.items && node.items.length > 0"
        :nodes="node.items"
        :checkedStateMap="checkedStateMap"
        :indent="indent + 20"
        :disableCheckbox="disableCheckbox"
        @toggle="$emit('toggle', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LvDropdownTreeCheckboxNode',
  props: {
    nodes: {
      type: Array,
      default() {
        return [];
      },
    },
    checkedStateMap: {
      type: Object,
      default() {
        return {};
      },
    },
    indent: {
      type: Number,
      default: 0,
    },
    disableCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_getSelectValue(nodeId) {
      const state = this.checkedStateMap[nodeId];
      if (state && state.checked) {
        return [nodeId];
      }
      return [];
    },
    $_isParentSelected(nodeId) {
      const state = this.checkedStateMap[nodeId];
      return state ? state.indeterminate : false;
    },
    $_onToggle(node) {
      this.$emit('toggle', node);
    },
  },
};
</script>

<style lang="scss" scoped>
.lv-dropdown-tree-checkbox-node__item {
  margin-bottom: 4px;
}
</style>
